// timeout with option to await on it
export function awaitableTimeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
//# sourceMappingURL=AwaitableTimeout.js.map